import { Card, Skeleton, Space } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ConfirmAndContinueButton from '../../../components/buttons/ConfirmAndContinueButton';
import PreviousButton from '../../../components/buttons/PreviousButton';
import SecondaryProgramScenarioDataTable from '../../../components/datatables/secondary/SecondaryProgramScenarioDataTable';
import DataReviewLayout from '../../../components/secondary/DataReviewLayout';
import Breadcrumbs from '../../../config/Breadcrumbs';
import Routes from '../../../config/Routes';
import HistoryUtil from '../../../utils/HistoryUtil';
import ParameterUtil from '../../../utils/ParameterUtil';

interface SecondaryProgramScenarioListPageState {
  academicYear: number;
}

interface SecondaryProgramScenarioListPageProps {
}

class DataReviewSecondaryProgramScenarioListPage extends React.Component<SecondaryProgramScenarioListPageProps & RouteComponentProps<RouteObject>, SecondaryProgramScenarioListPageState> {

  constructor(props: SecondaryProgramScenarioListPageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      academicYear: 0
    };
  }

  componentDidMount() {
    const id = Number.parseInt(ParameterUtil.getPathPart(this.props.match, 'academicYearId'));

    if (this.state.academicYear != id) {
      this.setState({ academicYear: id });
    }
  }

  private onBack = () => {
    HistoryUtil.push(Routes.generate(Routes.DATA_REVIEW_FEDERAL_CLUSTERS, { academicYearId: this.state.academicYear }, {}));
  }

  private onContinue = () => {
    HistoryUtil.push(Routes.generate(Routes.DATA_REVIEW_REGIONAL_PLANNING_PARTNER, { academicYear: this.state.academicYear }, {}));
  }

  render() {
    const academicYear = this.state.academicYear == 0 ? 0 : this.state.academicYear;

    if (academicYear != 0) {
      return (
        <Content >
          <DataReviewLayout breadcrumbs={Breadcrumbs.academicYearDataReview(academicYear)} stepNumber={3} academicYear={academicYear}>
            <Card title="Scenarios">
              <Space direction='vertical' size="middle">
                <SecondaryProgramScenarioDataTable academicYear={this.state.academicYear} />
                <Space>
                  <PreviousButton onClick={this.onBack} />
                  <ConfirmAndContinueButton onClick={this.onContinue} />
                </Space>
              </Space>
            </Card>
          </DataReviewLayout>
        </Content>
      );
    }

    return <Skeleton />;
  }
}

export default withRouter((DataReviewSecondaryProgramScenarioListPage));
